import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ApplyPlanBody } from './ApplyPlanBody';

export function ApplyPlanDialog({
  incidentId,
  positionId,
  positionName,
  onClose,
}: {
  incidentId: string;
  /** When set, every created task is assigned to this roster seat. */
  positionId?: string;
  positionName?: string;
  onClose: () => void;
}) {
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="dark tw:sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Apply plan</DialogTitle>
          <DialogDescription className="tw:sr-only">
            Apply a plan from the library to this workspace
          </DialogDescription>
        </DialogHeader>
        <ApplyPlanBody
          incidentId={incidentId}
          positionId={positionId}
          positionName={positionName}
          onApplied={onClose}
          footer={({ applyDisabled, applyPending, onApply }) => (
            <DialogFooter>
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button
                type="button"
                disabled={applyDisabled}
                onClick={onApply}
              >
                {applyPending ? 'Applying…' : 'Apply plan'}
              </Button>
            </DialogFooter>
          )}
        />
      </DialogContent>
    </Dialog>
  );
}
